import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useUnreadSummary } from '@/hooks/messaging/useUnreadSummary';
import { useAuth } from '@/contexts/AuthContext';

const SESSION_KEY_PREFIX = 'msg-login-banner-shown-v1:';

// Mount once near the top of the authenticated app. Once per browser
// session per profile, surfaces a Sonner toast if there are unread
// messages waiting.
export const LoginUnreadBanner = () => {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const { totalUnreadCount, data, isSuccess } = useUnreadSummary();

  useEffect(() => {
    if (!isSuccess || !profile?.id) return;
    if (totalUnreadCount <= 0) return;

    const key = `${SESSION_KEY_PREFIX}${profile.id}`;
    try {
      if (window.sessionStorage.getItem(key) === '1') return;
      window.sessionStorage.setItem(key, '1');
    } catch {
      /* sessionStorage may be unavailable in some embedded contexts */
    }

    const threads = data?.filter((r) => r.unread_count > 0).length ?? 0;
    toast.message(
      `You have ${totalUnreadCount} unread message${totalUnreadCount === 1 ? '' : 's'}` +
        (threads > 1 ? ` across ${threads} conversations` : ''),
      {
        action: {
          label: 'Open inbox',
          onClick: () => navigate('/messages'),
        },
        duration: 8000,
      },
    );
  }, [isSuccess, totalUnreadCount, data, profile?.id, navigate]);

  return null;
};
